import { useEffect } from 'react'

/** Sets the tab title as "<title> · bPanel" (or "bPanel" without a title). PageHeader calls it for you. */
export function useDocumentTitle(title?: string | null) {
  useEffect(() => {
    document.title = title ? `${title} · bPanel` : 'bPanel'
  }, [title])
}
